import { DEFAULT_STREAM_BIND_MODAL_STATE, DEFAULT_STREAM_SET_POINTS_INPUT_STATE } from './consts';
import {
  StreamBindModalAction,
  StreamBindModalActionTypes,
  StreamBindModalState,
  StreamSetPointsInputAction,
  StreamSetPointsInputActionTypes,
  StreamSetPointsInputState,
} from './types';

export const streamBindModalReducer = (
  state: StreamBindModalState,
  action: StreamBindModalAction
): StreamBindModalState => {
  switch (action.type) {
    case StreamBindModalActionTypes.SET_SELECTED_POINTS: {
      return {
        ...state,
        selectedPoints: action.selectedPoints,
      };
    }
    case StreamBindModalActionTypes.SET_DISABLED_POINTS: {
      return {
        ...state,
        disabledPoints: action.disabledPoints,
      };
    }
    case StreamBindModalActionTypes.SET_SEARCH_TEXT: {
      return {
        ...state,
        searchText: action.searchText,
      };
    }
    case StreamBindModalActionTypes.SET_IS_BIND_LOADING: {
      return {
        ...state,
        isBindLoading: action.isBindLoading,
      };
    }
    case StreamBindModalActionTypes.RESET_STATE: {
      return {
        ...state,
        ...DEFAULT_STREAM_BIND_MODAL_STATE,
      };
    }
    default:
      return state;
  }
};

export const streamSetPointsInputReducer = (
  state: StreamSetPointsInputState,
  action: StreamSetPointsInputAction
): StreamSetPointsInputState => {
  switch (action.type) {
    case StreamSetPointsInputActionTypes.SET_INITIAL_POINT_IDS: {
      return {
        ...state,
        filter: {
          ...state.filter,
          initialPointIds: action.initialPointIds,
        },
      };
    }
    case StreamSetPointsInputActionTypes.SET_POINT: {
      const newPointIds = new Map(state.filter?.pointIds);
      const needAdd = action.needAdd;

      if (needAdd) {
        newPointIds.set(action.point.id, action.point);
      } else {
        newPointIds.delete(action.point.id);
      }

      return {
        ...state,
        filter: {
          ...state.filter,
          pointIds: newPointIds,
        },
      };
    }
    case StreamSetPointsInputActionTypes.RESET_STATE: {
      return {
        filter: DEFAULT_STREAM_SET_POINTS_INPUT_STATE.filter,
      };
    }
    default:
      return state;
  }
};
